module.exports = __webpack_public_path__ + "media/tolmex/favicon-c44f4b92.ico";